import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import theme from "../../../../Styles/theme";
import { IUsuario, useUsuario } from "../../../../Hooks/UsuarioHook";
import { useUsuarioStorage } from "../../../../Storage/UsuariosStorage";

interface DeleteProfilePhotoModalProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;
}

export const ExcluirFotoPerfilModal: React.FC<DeleteProfilePhotoModalProps> = ({
  open,
  onClose,
}) => {
  const {  usuario } = useUsuario();
  const {usuarioFocus,atualiza_criaUsuario,setUsuarioFocus } = useUsuarioStorage();
  const handleClose = () => {
    onClose(false);
  };

  const handleDeleteProfilePhoto = async() => {
    const formData = new FormData();
    formData.append("foto", ""); // Convertendo para string
    formData.append("id", usuarioFocus.usuario.id.toString()); // Convertendo para string
    const help = await atualiza_criaUsuario(formData);
    const usuario_ = {} as IUsuario;
    usuario_.usuario = help;
    // usuario_.usuario.foto = usuario_.usuario.foto
    //   ? api_login_unico_url + + usuario_.usuario.foto
    //   : "";
    usuario_.usuario.foto = usuario_.usuario.foto;
    setUsuarioFocus(usuario_);
    onClose(true);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h6" color="primary">
          Excluir Foto do Perfil
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Tem certeza de que deseja excluir sua foto de perfil?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{ color: theme.colors.darkGrey }}>
          Cancelar
        </Button>
        <Button onClick={handleDeleteProfilePhoto} color="error">
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};
